<template>
    <DCard padding>
        <DFormRow
            :label="__('users.edit.form.name')"
            :is-required="user.local"
            :error="errors.name"
        >
            <DInput
                v-if="user.local"
                id="name"
                v-model="form.name"
                :is-valid="isFormFieldValid('name')"
            />
            <span v-else>{{ user.name }}</span>
        </DFormRow>
        <DFormRow
            :label="__('users.edit.form.email')"
            :is-required="user.local"
            :error="errors.email"
        >
            <DInput
                v-if="user.local"
                id="email"
                v-model="form.email"
                :is-valid="isFormFieldValid('email')"
            />
            <span v-else>{{ user.email }}</span>
        </DFormRow>
        <DFormRow
            :label="__('users.edit.form.language')"
            :is-required="true"
            :error="errors.language"
        >
            <DSelect
                id="language"
                v-model="form.language"
                :options="languageOptions"
                :is-valid="errors.language ? false : null"
                @update:value="updateLanguage"
            />
        </DFormRow>
        <DFormRow
            :label="__('users.edit.form.assigned_role')"
            :is-required="true"
            :error="errors.role"
        >
            <span v-if="isProduction">{{ userRoleName }}</span>
            <DSelect
                v-else
                id="role"
                v-model="form.role"
                :placeholder="__('users.edit.form.select_role')"
                :options="roleOptions"
                :is-valid="errors.role ? false : null"
                @update:value="updateRole"
            />
        </DFormRow>
        <DFormRow
            :label="__('users.edit.form.items_per_page')"
            :is-required="true"
            :error="errors.ui_pagesize"
        >
            <DSelect
                id="page_size"
                v-model="form.ui_pagesize"
                :placeholder="__('users.edit.form.select_items_per_page')"
                :options="uiPageSizeOptions"
                :is-valid="errors.ui_pagesize ? false : null"
                @update:value="updatePaginationSize"
            />
        </DFormRow>
        <DFormRow
            v-if="user.local"
            :label="__('users.edit.form.display_name')"
            :error="errors.display_name"
        >
            <DInput
                id="display_name"
                v-model="form.display_name"
                :placeholder="user.name"
                :is-valid="isFormFieldValid('display_name')"
            />
        </DFormRow>
        <DFormRow
            v-if="user.local"
            :label="__('users.edit.form.password')"
            :error="errors.password"
        >
            <DInput
                id="password"
                v-model="form.password"
                :is-valid="isFormFieldValid('password')"
                type="password"
            />
        </DFormRow>
        <DFormControls
            :key="reloadKey"
            :cancel-route="$route('users.edit', {user: user.id})"
            @submit="saveUser"
        />
    </DCard>
</template>

<script>
export default {
    name: 'UserEdit',
    props: {
        user: {
            type: Object,
            default: () => { return {} }
        },
        isProduction: {
            type: Boolean,
            default: true
        },
        roles: {
            type: Array,
            default: () => { return [] }
        },
        languages: {
            type: Array,
            default: () => { return [] }
        },
        paginationOptions: {
            type: Array,
            default: () => { return [] }
        },
        can: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                language: this.user.language_code ?? 'en',
                role: this.user.roles[0]?.id,
                ui_pagesize: this.user.ui_pagesize ?? 25,
                display_name: this.user.display_name,
                password: null,
                name: this.user.name,
                email: this.user.email
            }),
            reloadKey: 0
        }
    },
    computed: {
        userRoleName () {
            return this.roles.find(role => role.id === this.form.role)?.name
        },
        roleOptions () {
            return this.roles.map(role => {
                return { value: role.id, label: role.name }
            })
        },
        languageOptions () {
            return this.languages.map(language => {
                return { value: language.code, label: language.name }
            })
        },
        uiPageSizeOptions () {
            return this.paginationOptions.map(option => {
                return { value: option, label: option }
            })
        }
    },
    methods: {
        saveUser () {
            this.$inertia.put(this.$route('users.update', { user: this.user.id }), this.form, {
                onSuccess: () => {
                    ++this.reloadKey
                }
            })
        },
        updateLanguage (value) {
            this.form.language = value
        },
        updateRole (value) {
            this.form.role = value
        },
        updatePaginationSize (value) {
            this.form.ui_pagesize = value
        }
    }
}
</script>
